import React from "react";
import { Link } from "react-router-dom";
import "./LegalPage.scss";

export default function ContactPage() {
  return (
    <div className="netflix-app container-fluid legal-page-shell">
      <article className="legal-page">
        <h1 className="legal-page__title">Contact</h1>
        <p className="legal-page__text">
          If you have questions or complaints about this Privacy Policy or our
          privacy practices, please contact us at{" "}
          <a
            className="legal-page__link"
            href="mailto:s@dataSCIsive.com"
          >
            s@dataSCIsive.com
          </a>.
        </p>
      </article>
    </div>
  );
}
